<template>
  <div>
    <v-alert v-show="true" color="primary" value="true" outline>
      {{ $t('botWarning') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>. {{ $t('botWarning3') }}
    </v-alert> 
    <!-- Indique si la licence n'a pas l'option ChatBot -->
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      {{ $t('botWarning2') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <div v-if="!alert">
      <!-- Chargement -->
      <div v-if="loadingGet" class="text-xs-center">
        <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
      </div>
      <!-- ON / OFF -->
      <v-card v-else class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs12 md6>
              <v-switch 
                :label="onOff ? 'CHATBOT ON' : 'CHATBOT OFF'"
                v-model="onOff"
                light
                color="primary"
              ></v-switch>
            </v-flex>

            <v-flex xs12 md6>
              <!-- CHOIX BOTS -->
              <v-layout row wrap v-if="onOff">
                <div md6 style="display: flex; align-items: center;">
                  chatbot selectionné : <strong> {{ botSelected[0].USR_FIRST_NAME }} {{ botSelected[0].USR_LAST_NAME }} </strong>
                </div>
                <v-flex md6>
                  <wz-select-bots
                    label="Choisissez le Bot"
                    :bot.sync="bot"
                    :listeBots="$store.state._User.bots"
                    :openFromExt="openBeforeclose"
                    :testChatbot="false"
                    @reInitBots="reInitBots"
                  ></wz-select-bots>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-expansion-panel>
        <!-- OPTIONS DU BOT -->
        <v-expansion-panel-content>
          <div slot="header"><v-icon class="primary--text">settings</v-icon>{{ $t('botOptions') }}</div>
          <v-card>
            <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <!-- Masquer sur mobile -->
                  <v-switch 
                    :label="contextPriorityBot" 
                    v-model="optionNoAgent"
                    light
                    color="primary"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-switch 
                    :label="$t('botBoutons')" 
                    v-model="buttonsHorizontal"
                    light
                    color="primary"
                    :hint="$t('botBoutons2')"
                    persistent-hint
                    :disabled="!onOff"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-switch 
                    :label="$t('botBloquer')" 
                    v-model="blocTextarea"
                    light
                    color="primary"
                    :hint="$t('botWatson')"
                    persistent-hint
                    :disabled="!onOff"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- HORAIRES -->
        <v-expansion-panel-content
          :class="[ getPermissions ? 'active' : 'hidden' ]"
        > 
          <div slot="header">
            <v-icon class="primary--text">schedule</v-icon> 
             {{ $t('botRestric') }} 
            <v-tooltip left
              @click.native.stop="openDialog(
                {
                  title: $t('botVisualiser') ,
                  content: $t('botVisuDesc') 
                }
              )"
            >
              <template slot="activator">
                <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
              </template>
              <span>{{$t('enSavoirPlus')}}</span>
            </v-tooltip>
          </div>
          <v-card>
            <v-card-text>
              <v-card class="mb-3">
                <v-card-text>
                  <div slot="header">{{ $t('displayTimes') | cap }}</div>
                  <v-layout>
                    <v-flex xs12 sm12 md6>
                      <!-- Horaires d'affichage -->
                      <v-radio-group v-model="form.hours" :hint="$t('defineWidgetHours')" persistent-hint>
                        <v-radio :label="$t('allTheTime') | cap" color="primary" value="all"></v-radio>
                        <v-radio :label="$t('customHours')  | cap" color="primary" value="defined"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <!-- Définition des horaires -->
                  <v-layout v-if="form.hours == 'defined'" row wrap>
                    <v-flex xs12>
                      <v-btn flat class="primary--text" @click="openHours()">{{ $t('timesSeveralDays') }}<v-icon right>event</v-icon></v-btn>
                    </v-flex>
                    <v-expansion-panel>
                      <v-expansion-panel-content v-for="day in form.days" :key="day.name">
                        <v-layout align-center row spacer slot="header">
                          <v-flex xs12>
                            <span class="hidden-md-and-up">{{ day.name.substring(0, 3) }}. : </span>
                            <span class="hidden-sm-and-down">{{ day.name }} : </span>
                            <span v-if="day.am.active || day.pm.active">
                              <span v-if="day.am.active"> {{ $t('from') }}<code>{{ day.am.start }}</code> {{ $t('to') }} <code>{{ day.am.end }}</code></span>
                              <span v-if="day.am.active && day.pm.active"> {{ $t('and') }}</span>
                              <span v-if="day.pm.active">{{ $t('from') }} <code>{{ day.pm.start }}</code> {{ $t('to') }} <code>{{ day.pm.end }}</code></span>
                            </span>
                            <span v-else>
                              <span>{{ $t('disabledToday') | cap }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-card class="grey lighten-3">
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md2>
                                <!-- Activer le matin -->
                                <v-switch 
                                  :label="$t('activateMorning') | cap " 
                                  v-model="day.am.active"
                                  light
                                  color="primary"
                                ></v-switch>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <!-- Temps Matin -->
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('from') + ` ${ day.name } ` + $t('morning')"
                                  v-model="day.am.start"
                                  prepend-icon="access_time"
                                  :disabled="!day.am.active"
                                  readonly
                                  @click="openTimePicker(day, 'am', 'start')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('to') + ` ${ day.name } ` + $t('morning')"
                                  v-model="day.am.end"
                                  prepend-icon="access_time"
                                  :disabled="!day.am.active"
                                  readonly
                                  @click="openTimePicker(day, 'am', 'end')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md2>
                                <!-- Activer l'après-midi -->
                                <v-switch 
                                  :label="$t('activateAfternoon') | cap " 
                                  v-model="day.pm.active"
                                  light
                                  color="primary"
                                ></v-switch>
                              </v-flex>
                              <!-- Temps Après-midi -->
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('from') + ` ${ day.name } ` + $t('afternoon')"
                                  v-model="day.pm.start"
                                  prepend-icon="access_time"
                                  :disabled="!day.pm.active"
                                  readonly
                                  @click="openTimePicker(day, 'pm', 'start')"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md2>
                                <v-text-field 
                                  slot="activator"
                                  :label="$t('to') + ` ${ day.name } ` + $t('afternoon')"
                                  v-model="day.pm.end"
                                  prepend-icon="access_time"
                                  :disabled="!day.pm.active"
                                  readonly
                                  @click="openTimePicker(day, 'pm', 'end')"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- BLACK LISTS -->
        <v-expansion-panel-content>
          <div slot="header"><v-icon class="mr-2 primary--text">language</v-icon>
            {{ $t('urlDisplay') | cap }}
            <v-tooltip left
              @click.native.stop="openDialog(
                {
                  title: $t('botVisualiser2') ,
                  content: $t('botVisuDesc2')                 }
              )"
            >
              <template slot="activator">
                <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
              </template>
              <span>{{$t('enSavoirPlus')}}</span>
            </v-tooltip>
          </div>
          <v-card>
            <v-card-text>
              <v-card class="mb-3">
                <v-card-text>
                  <v-layout>
                    <v-flex xs12>
                      <v-radio-group v-model="form.urls" :hint="$t('chooseWhiteOrBlackChatbot')" persistent-hint>
                        <v-radio :label="$t('everywhere') | cap " color="primary" value="all"></v-radio>
                        <v-radio label="White List" color="primary" value="showOnOff"></v-radio>
                        <v-radio label="Black List" color="primary" value="hideOnOff"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-show="form.urls != 'all'">
                    <v-flex xs12>
                      <v-card>
                        <v-card-text>
                            <v-fab-transition slot="activator">
                              <v-btn
                                v-show="form.urls != 'all'"
                                class="secondary"
                                dark
                                absolute
                                top
                                right
                                fab
                                @click.stop="openRule()"
                              >
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-fab-transition>
                          <v-data-table
                            :headers="headersRules"
                            :items="form.rules"
                            :no-data-text="$t('noRules')"
                            hide-actions
                          >
                            <template slot="items" slot-scope="props">
                              <td v-if="props.item.list === form.urls">
                                <v-edit-dialog
                                  :return-value.sync="props.item.type"
                                  :cancel-text="$t('cancel')"
                                  :save-text="$t('submit')"
                                  large
                                >
                                  <div>{{ props.item.type.text }}</div>
                                  <div slot="input" class="mt-3 title">{{ $t('changeType') }}</div>
                                  <v-select
                                    slot="input"
                                    :items="typeRules"
                                    v-model="props.item.type"
                                    return-object
                                    autofocus
                                  ></v-select>
                                </v-edit-dialog>
                              </td>
                              <td v-if="props.item.list === form.urls">
                                <v-edit-dialog
                                  :cancel-text="$t('cancel')"
                                  :save-text="$t('submit')"
                                  :return-value.sync="props.item.content"
                                  large
                                  lazy
                                >
                                  <div><code>{{ props.item.content }}</code></div>
                                  <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                                  <v-text-field
                                    slot="input"
                                    label="Modification"
                                    v-model="props.item.content"
                                    single-line
                                    counter
                                    autofocus
                                  ></v-text-field>
                                </v-edit-dialog>
                              </td>
                              <td v-if="props.item.list === form.urls" class="text-xs-right">
                                <v-btn icon flat @click.stop="deleteRule(props.index)">
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>

                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>



      <!-- Chargement -->
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
      </div>
      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="postOptions()"
        >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>

      <!-- dialog Infos -->
      <wz-dialog-infos
        @fermeDialog="fermeDialogInfos"
        :titleDialog="titleDialog"
        :contentDialog="contentDialog"
      >
      </wz-dialog-infos>

      <!-- Time picker -->
      <v-dialog persistent v-model="showTp" lazy max-width="290">
        <v-time-picker 
          v-model="daySelected[amOrPm][startOrEnd]"
          actions
          scrollable
          format="24hr"
          :max="allowed.hours.max"
          :min="allowed.hours.min"
          color="primary"
        >
          <v-spacer></v-spacer>
          <v-btn flat @click="showTp = false; daySelected[amOrPm][startOrEnd] = tmpHours">{{ $t('cancel') | cap }}</v-btn>
          <v-btn flat color="primary" @click="showTp = false">{{ $t('submit') | cap }}</v-btn>
        </v-time-picker>
      </v-dialog>
     
      <!-- Appliquer les horaires d'une journée -->
      <v-dialog v-model="showHours" scrollable persistent width="350px">
        <v-card>
          <v-card-title class="primary white--text">{{ $t('applySchedules') | cap }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px;">
            <v-select
              :items="days"
              v-model="dayHours"
              :label="$t('applyHours')" 
              return-object
            ></v-select>
            <v-data-table
              :headers="headersDays"
              :items="days"
              v-model="daysTmp"
              item-key="text"
              select-all="primary"
              class="elevation-1"
              hide-actions
              :total-items="7"
            >
              <template slot="headerCell" slot-scope="props">
                <span class="subheading">{{ props.header.text }}</span>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    hide-details
                    class="primary--text"
                    v-model="props.selected"
                  ></v-checkbox>
                </td>
                <td>{{ props.item.text }}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showHours = false">{{ $t('cancel') }}</v-btn>
            <v-btn :disabled="!daysTmp.length" color="primary" flat @click="submitHours()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <!-- DIALOGUE Création règle-->
      <v-dialog v-model="showDialogRule" persistent max-width="290">
        <v-card>
          <v-card-title class="primary white--text">{{ $t('createRule') | cap }}</v-card-title>
          <v-card-text>
            <form>
              <v-select
                v-model="ruleTmp.type"
                :items="typeRules"
                :label="$t('ruleType')"  
                return-object
                required
                v-validate="'required'" 
                data-vv-name="select"
                :error="wzErrors.has('select')"
                :error-messages="wzErrors.collect('select')"
              ></v-select>
              <v-text-field
                autofocus
                v-model="ruleTmp.content"
                :label="$t('ruleContent')" 
                required
                v-validate="'required'" 
                data-vv-name="ruleContentInput"
                :error="wzErrors.has('ruleContentInput')"
                :error-messages="wzErrors.collect('ruleContentInput')"
                @keyup.native.enter="submitRule()"
              ></v-text-field>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogRule = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" flat @click="submitRule()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
// Socket
// import _watcheebox from '../watcheebox/watcheebox.js'
export default {
  data () {
    return {
      titleDialog: '',
      contentDialog: '',
      alert: false,
      onOff: false,
      buttonsHorizontal: true,
      blocTextarea: true,
      optionNoAgent: '',
      choosen: '',
      dialogImport: false,
      agent: {},
      agentSource: {},
      loadingImport: false,
      bot: [],
      form: {
        // horaires d'affichage
        hours: '',
        days: [
          {
            name: this.$t('monday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('tuesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('wednesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('thursday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('friday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('saturday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('sunday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          }
        ],
        // URLs d'affichage
        urls: '',
        rules: []
      },
      // time pickers
      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',
      hideIcon: '',
      // dialog appliquer les horaires
      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [
        { text: _.upperFirst(this.$t('monday')), value: 0 },
        { text: _.upperFirst(this.$t('tuesday')), value: 1 },
        { text: _.upperFirst(this.$t('wednesday')), value: 2 },
        { text: _.upperFirst(this.$t('thursday')), value: 3 },
        { text: _.upperFirst(this.$t('friday')), value: 4 },
        { text: _.upperFirst(this.$t('saturday')), value: 5 },
        { text: _.upperFirst(this.$t('sunday')), value: 6 }
      ],
      // URLs d'affichage
      tmp: '',
      headersRules: [
        { text: _.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' },
        { text: _.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' },
        { text: '', align: 'left', sortable: false, value: 'actions' }
      ],
      typeRules: [
        { text: _.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' },
        { text: _.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' },
        { text: _.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' },
        { text: _.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }
      ],
      showDialogRule: false,
      ruleTmp: {content: '', type: {}},
       /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
      // loaders
      loadingGet: false,
      loadingPost: false,
      dialogProgress: false,
      openBeforeclose: false,
      botSelected: [{
        USR_FIRST_NAME: '',
        USR_LAST_NAME: '',
        USR_ID: 0,
        USR_WATSON: null
      }]
    }
  },

  mounted () {
    this.getOptions()
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
  },
  created () {
    this.daySelected = this.form.days[0]
    this.dayHours = { text: this.form.days[0].name, value: 0 }
    this.selectBot()
  },
  computed: {
    ...mapGetters('_User', [ 'user' ]),
    activeFilters () {
      return 1
    },
    headersDays () {
      return !this.daysTmp.length
      ? [{text: this.$t('allDays'), align: 'left', sortable: false}]
      : [{text: this.$t('noDays'), align: 'left', sortable: false}]
    },
    contextPriorityBot () {
      if (this.optionNoAgent) {
        return this.$t('botPrioriteOn')
      } else {
        return this.$t('botPrioriteOff')
      }
    }
  },
  methods: {
    selectBot () {
      // console.log('selectBot', this.$store.state._User.botSelected)
      if (this.$store.state._User.botSelected.length) {
        this.bot = this.$store.state._User.botSelected
      } else {
        // par default c'est le premier de la list
        this.bot.splice(0, 1, this.$store.state._User.bots[0])
      }
      if (this.bot[0] && this.bot[0].USR_WATSON && this.bot[0].USR_WATSON !== '') {
        this.botWorkspace = this.bot[0].USR_WATSON
      }
      // this.selectBotBKP = this.bot
      // console.log('clobe liste bot', this.selectBotBKP)
      // this.loading = false
    },
    reInitBots () {
      // si on change de bot, il faut effacer l'id du repertoire de la base de connaissance
      this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', '')
      this.bot = this.$store.state._User.botSelected
      // console.log('reinitbot bot : ', this.bot)
      // console.log('reinitbot LIC_DSK_ID : ', this.$store.state._Sites.siteSelected.LIC_DSK_ID)
    },
    getOptions () {
      console.log('getOptions')
      if (
        this.$store.state._Sites.siteSelected.LIC_BOT_ACTIVATED !== '1'
      ) {
        this.alert = true
        return
      }
      this.alert = false
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_bot.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          this.onOff = response.data.DSK_BOT_ONOFF === '1'
          this.buttonsHorizontal = response.data.DSK_BOT_BUTTONS_HORIZONTAL === '1'
          this.blocTextarea = response.data.DSK_BOT_TEXTAREA === '1'
          this.optionNoAgent = response.data.DSK_BOT_OPTION === 'noagent'
          console.log('response', response)
          let botchoosen = JSON.parse(response.data.DSK_BOT_USER) || {}
          this.choosen = botchoosen['user_id']
          console.log('botchoosen', botchoosen)
          console.log('this.bot', this.bot)
          this.botSelected = [
            {
              USR_FIRST_NAME: botchoosen['user_name'],
              USR_LAST_NAME: '',
              USR_ID: botchoosen['user_id'],
              USR_WATSON: botchoosen['user_watson']
            }
          ]
          console.log('this.botSelected', this.botSelected)
          // options URL
          this.form.urls = 'all'
          if (response.data.DSK_BOT_SHOW_ONOFF === '1') {
            this.form.urls = 'showOnOff'
          } else if (response.data.DSK_BOT_HIDE_ONOFF === '1') {
            this.form.urls = 'hideOnOff'
          }
          this.form.rules = []
          // urls white list
          _.each(response.data.DSK_BOT_SHOW_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_BOT_SHOW_PART_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_BOT_SHOW_TAGS.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_BOT_SHOW_CLASS_ID.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'showOnOff' })
          })
          // urls black list
          _.each(response.data.DSK_BOT_HIDE_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_BOT_HIDE_PART_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_BOT_HIDE_TAGS.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_BOT_HIDE_CLASS_ID.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'hideOnOff' })
          })

          // options horaires
          this.form.hours = response.data.DSK_SCHEDULES_BOT.split('|')[0]
          let hours = response.data.DSK_SCHEDULES_BOT.split('|')
          // lundi
          this.form.days[0].am.active = !_.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !_.isNil(hours[1]) && !_.isNil(hours[2]) && !_.isNil(hours[3]) && !_.isNil(hours[4])
          this.form.days[0].am.start = (this.form.days[0].am.active) ? hours[1] + ':' + hours[2] : '00:00'
          this.form.days[0].am.end = (this.form.days[0].am.active) ? hours[3] + ':' + hours[4] : '00:00'
          this.form.days[0].pm.active = !_.isEmpty(hours[5] + hours[6] + hours[7] + hours[8])
          this.form.days[0].pm.start = (this.form.days[0].pm.active) ? hours[5] + ':' + hours[6] : '12:00'
          this.form.days[0].pm.end = (this.form.days[0].pm.active) ? hours[7] + ':' + hours[8] : '12:00'
          // mardi
          this.form.days[1].am.active = !_.isEmpty(hours[9] + hours[10] + hours[11] + hours[12])
          this.form.days[1].am.start = (this.form.days[1].am.active) ? hours[9] + ':' + hours[10] : '00:00'
          this.form.days[1].am.end = (this.form.days[1].am.active) ? hours[11] + ':' + hours[12] : '00:00'
          this.form.days[1].pm.active = !_.isEmpty(hours[13] + hours[14] + hours[15] + hours[16])
          this.form.days[1].pm.start = (this.form.days[1].am.active) ? hours[13] + ':' + hours[14] : '12:00'
          this.form.days[1].pm.end = (this.form.days[1].am.active) ? hours[15] + ':' + hours[16] : '12:00'
          // mercredi
          this.form.days[2].am.active = !_.isEmpty(hours[17] + hours[18] + hours[19] + hours[20])
          this.form.days[2].am.start = (this.form.days[2].am.active) ? hours[17] + ':' + hours[18] : '00:00'
          this.form.days[2].am.end = (this.form.days[2].am.active) ? hours[19] + ':' + hours[20] : '00:00'
          this.form.days[2].pm.active = !_.isEmpty(hours[21] + hours[22] + hours[23] + hours[24])
          this.form.days[2].pm.start = (this.form.days[2].pm.active) ? hours[21] + ':' + hours[22] : '12:00'
          this.form.days[2].pm.end = (this.form.days[2].pm.active) ? hours[23] + ':' + hours[24] : '12:00'
          // jeudi
          this.form.days[3].am.active = !_.isEmpty(hours[25] + hours[26] + hours[27] + hours[28])
          this.form.days[3].am.start = (this.form.days[3].am.active) ? hours[25] + ':' + hours[26] : '00:00'
          this.form.days[3].am.end = (this.form.days[3].am.active) ? hours[27] + ':' + hours[28] : '00:00'
          this.form.days[3].pm.active = !_.isEmpty(hours[29] + hours[30] + hours[31] + hours[32])
          this.form.days[3].pm.start = (this.form.days[3].pm.active) ? hours[29] + ':' + hours[30] : '12:00'
          this.form.days[3].pm.end = (this.form.days[3].pm.active) ? hours[31] + ':' + hours[32] : '12:00'
          // vendredi
          this.form.days[4].am.active = !_.isEmpty(hours[33] + hours[34] + hours[35] + hours[36])
          this.form.days[4].am.start = (this.form.days[4].am.active) ? hours[33] + ':' + hours[34] : '00:00'
          this.form.days[4].am.end = (this.form.days[4].am.active) ? hours[35] + ':' + hours[36] : '00:00'
          this.form.days[4].pm.active = !_.isEmpty(hours[37] + hours[38] + hours[39] + hours[40])
          this.form.days[4].pm.start = (this.form.days[4].pm.active) ? hours[37] + ':' + hours[38] : '12:00'
          this.form.days[4].pm.end = (this.form.days[4].pm.active) ? hours[39] + ':' + hours[40] : '12:00'
          // samedi
          this.form.days[5].am.active = !_.isEmpty(hours[41] + hours[42] + hours[43] + hours[44])
          this.form.days[5].am.start = (this.form.days[5].am.active) ? hours[41] + ':' + hours[42] : '00:00'
          this.form.days[5].am.end = (this.form.days[5].am.active) ? hours[43] + ':' + hours[44] : '00:00'
          this.form.days[5].pm.active = !_.isEmpty(hours[45] + hours[46] + hours[47] + hours[48])
          this.form.days[5].pm.start = (this.form.days[5].pm.active) ? hours[45] + ':' + hours[46] : '12:00'
          this.form.days[5].pm.end = (this.form.days[5].pm.active) ? hours[47] + ':' + hours[48] : '12:00'
          // dimanche
          this.form.days[6].am.active = !_.isEmpty(hours[49] + hours[50] + hours[51] + hours[52])
          this.form.days[6].am.start = (this.form.days[6].am.active) ? hours[49] + ':' + hours[50] : '00:00'
          this.form.days[6].am.end = (this.form.days[6].am.active) ? hours[51] + ':' + hours[52] : '00:00'
          this.form.days[6].pm.active = !_.isEmpty(hours[53] + hours[54] + hours[55] + hours[56])
          this.form.days[6].pm.start = (this.form.days[6].pm.active) ? hours[53] + ':' + hours[54] : '12:00'
          this.form.days[6].pm.end = (this.form.days[6].pm.active) ? hours[55] + ':' + hours[56] : '12:00'
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },
    postOptions () {
      console.log('postOptions this.onOff', this.onOff)
      // Si il faut un chatBot
      this.presenceChatBot()

      if (this.onOff === false || (this.bot[0] && this.bot[0].USR_ID && typeof this.bot[0].USR_ID !== 'undefined') || (this.$store.state._User.bots.length === 1 && this.choosen && this.choosen !== 'undefined' && this.choosen !== '' && this.choosen !== '0')) {
        let botUsrId = ''
        if (this.bot[0] && this.bot[0].USR_ID && typeof this.bot[0].USR_ID !== 'undefined') {
          botUsrId = this.bot[0].USR_ID
        } else if (this.$store.state._User.bots.length === 1 && this.choosen && this.choosen !== 'undefined' && this.choosen !== '' && this.choosen !== '0') {
          botUsrId = this.choosen
        }

        this.botSelected = [
          {
            USR_FIRST_NAME: this.bot[0].USR_FIRST_NAME,
            USR_LAST_NAME: this.bot[0].USR_LAST_NAME,
            USR_ID: botUsrId,
            USR_WATSON: this.bot[0].USR_WATSON
          }
        ]
        console.log('postOptions :: botUsrId', botUsrId)
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append(
          'DSK_ID',
          this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        dataToPost.append(
          'LIC_KEY',
          this.$store.state._Sites.siteSelected.LIC_KEY
        )
        dataToPost.append('DSK_BOT_ONOFF', this.onOff ? '1' : '0')
        dataToPost.append('DSK_BOT_BUTTONS_HORIZONTAL', this.buttonsHorizontal ? '1' : '0')
        dataToPost.append('bot_user_id', botUsrId)
        dataToPost.append('DSK_BOT_TEXTAREA', this.blocTextarea ? '1' : '0')
        dataToPost.append('DSK_BOT_OPTION', this.optionNoAgent ? 'noagent' : '')

        // options URLs
        dataToPost.append('DSK_BOT_HIDE_ONOFF', (this.form.urls === 'hideOnOff') ? '1' : '0')
        dataToPost.append('DSK_BOT_SHOW_ONOFF', (this.form.urls === 'showOnOff') ? '1' : '0')
        let url = {'showOnOff': '', hideOnOff: ''}
        let partUrl = {'showOnOff': '', hideOnOff: ''}
        let tags = {'showOnOff': '', hideOnOff: ''}
        let classId = {'showOnOff': '', hideOnOff: ''}
        _.each(this.form.rules, rule => {
          if (this.typeRules[0].value === rule.type.value) {
            url[rule.list] += rule.content + '|'
          } else if (this.typeRules[1].value === rule.type.value) {
            partUrl[rule.list] += rule.content + '|'
          } else if (this.typeRules[2].value === rule.type.value) {
            tags[rule.list] += rule.content + '|'
          } else if (this.typeRules[3].value === rule.type.value) {
            classId[rule.list] += rule.content + '|'
          }
        })
        dataToPost.append('DSK_BOT_SHOW_URL', url.showOnOff)
        dataToPost.append('DSK_BOT_SHOW_PART_URL', partUrl.showOnOff)
        dataToPost.append('DSK_BOT_SHOW_TAGS', tags.showOnOff)
        dataToPost.append('DSK_BOT_SHOW_CLASS_ID', classId.showOnOff)
        dataToPost.append('DSK_BOT_HIDE_URL', url.hideOnOff)
        dataToPost.append('DSK_BOT_HIDE_PART_URL', partUrl.hideOnOff)
        dataToPost.append('DSK_BOT_HIDE_TAGS', tags.hideOnOff)
        dataToPost.append('DSK_BOT_HIDE_CLASS_ID', classId.hideOnOff)

        // options horaires
        let hours = this.form.hours
        _.each(this.form.days, day => {
          hours += (day.am.active) // si Watcheezy actif le matin
          ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1]
          : '||||'
          hours += (day.pm.active) // si Watcheezy actif l'aprem
          ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1]
          : '||||'
        })
        dataToPost.append('DSK_SCHEDULES_BOT', hours)

        this.loadingPost = true
        this.axios
          .post('post/settings_bot.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('modifSuccess'),
              context: 'success'
            })
          })
          .catch(_ => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('modifFailure'),
              context: 'error'
            })
          })
          .then(_ => {
            this.loadingPost = false
          })
      } else {
        this.openBeforeclose = true
        // console.log('this.choosen')
        // console.log(this.choosen)
        // console.log('tiiiiiiiiiiiiiiii')
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Please select a bot in the list',
          context: 'error'
        })
      }
    },
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },
    openTimePicker (day, amOrPm, startOrEnd) {
      this.showTp = true // ouverture du dialog
      this.daySelected = day
      this.amOrPm = amOrPm
      this.startOrEnd = startOrEnd
      this.tmpHours = this.daySelected[amOrPm][startOrEnd]
      // heures et minutes autorisées dans le time pîcker
      this.allowed.hours = amOrPm === 'am'
      ? { min: '0:00', max: '12:59' } // matin
      : { min: '12:00', max: '23:59' } // aprem
    },
    /**
     * Gestion de l'application d'horaires à plusieurs jours
     */
    openHours () {
      this.showHours = true
    },
    submitHours () {
      this.showHours = false
      // pour tous les jours sélectionnés
      // il faut changer leurs horaires
      // par ceux du jour sélectionné
      const daySelected = this.form.days.find(d => d.name === this.dayHours.text)
      this.daysTmp.forEach(day => {
        let d = this.form.days.find(d => d.name === day.text.toLowerCase())
        d.am = _.cloneDeep(daySelected.am)
        d.pm = _.cloneDeep(daySelected.pm)
      })
      this.daysTmp = []
    },
    /**
     * Gestion des urls
     */
    openRule () {
      this.showDialogRule = true
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls }
    },
    submitRule () {
      if (!_.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false
        this.form.rules.push(_.clone(this.ruleTmp))
      } else {
        this.$validator.validateAll()
      }
    },
    deleteRule (index) {
      this.form.rules.splice(index, 1)
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    },

    // ---------------------------
    // regarde si il faut ajouter ou supprimer un chatBot
    presenceChatBot () {
      return new Promise(async (resolve, reject) => {
        if (this.onOff) {
          console.log('this.bot[0] = ', this.bot[0])
/*
          _watcheebox.addChatBot({
            datasAgent: this.bot[0],
            user: this.$store.state._User
          }, (response) => {
            if (response.success) {
              resolve({
                retour: 1,
                info: response.info,
                data: response
              })
            } else {
              reject({
                retour: 0,
                info: response.info,
                error: response
              })
            }
          })
*/

          let licAllKeys = Array.isArray(this.$store.state._User.licAllKeys) ? this.$store.state._User.licAllKeys.join('|') : ''
          let dataToPost = {
            roomName: this.$store.state._User.entKey,
            idBot: this.bot[0].USR_ID,
            agentEtat: 'online',
            agentConversation: 0,
            agentDevice: 0,
            sessionPHP: '',
            user_sites: '',
            keywords: '',
            priority: '',
            geteLang: this.$store.state._User.licLang,
            agentName: this.bot[0].USR_FIRST_NAME + ' ' + this.bot[0].USR_LAST_NAME,
            agentID: this.bot[0].USR_ID,
            agentJob: this.bot[0].USR_JOB ? this.bot[0].USR_JOB : '',
            agentAvatar: this.bot[0].USR_ID + '_avatar.jpg',
            WZAgentId: this.bot[0].USR_ID,
            entrepriseId: this.$store.state._User.entId,
            listLicKeysForThisAgent: licAllKeys,
            sid: this.$store.state._User.licenceId
          }
          // console.log('dataToPost', dataToPost)
          let urlRedis = 'https://lb-sw-prod.watcheebox.net/addChatBot'
          // si c'est en dev c'est pas la même url
          if (process.env.NODE_ENV === 'development') {
            // c'est du dev donc pas la même url
            urlRedis = 'https://lb-sw-moon-dev-v2.watcheebox.net/addChatBot'
          } else if (process.env.NODE_ENV === 'preprod') {
            // c'est du dev donc pas la même url
            urlRedis = 'https://lb-sw-moon-preprod-v2.watcheebox.net/addChatBot'
          }
          // console.log('url redis ', urlRedis)

          // ✅ Retourne directement la Promise
          try {
            const response = await this.axios.post(
              urlRedis,
              dataToPost
            )
            // console.log('delete bot response', response)
            return {
              retour: 1,
              data: response.data
            }
          } catch (err) {
            // console.log('delete bot err', err)
            return {
              retour: 0,
              data: err
            }
          }
        } else {
          // Suppression du bot côté Redis
          this.deleteChatBotRedis()
            .then((res) => {
              if (res.retour) {
                resolve({
                  retour: 1,
                  info: 'Bot supprimé avec succès',
                  data: res.data
                })
              } else {
                reject({
                  retour: 0,
                  info: 'Erreur suppression bot',
                  error: res.data
                })
              }
            })
            .catch((err) => {
              reject({
                retour: 0,
                info: 'Exception lors de la suppression du bot',
                error: err
              })
            })
        }
      })
    },

    async deleteChatBotRedis () {
      let dataToPost = {
        idBot: this.bot[0].USR_ID,
        entKey: this.$store.state._User.entKey
      }
      // console.log('dataToPost', dataToPost)
      let urlRedis = 'https://lb-sw-prod.watcheebox.net/deleteChatBot'
      // si c'est en dev c'est pas la même url
      if (process.env.NODE_ENV === 'development') {
        // c'est du dev donc pas la même url
        urlRedis = 'https://lb-sw-moon-dev-v2.watcheebox.net/deleteChatBot'
      } else if (process.env.NODE_ENV === 'preprod') {
        // c'est du dev donc pas la même url
        urlRedis = 'https://lb-sw-moon-preprod-v2.watcheebox.net/deleteChatBot'
      }
      // console.log('url redis ', urlRedis)

      // ✅ Retourne directement la Promise
      try {
        const response = await this.axios.post(
          urlRedis,
          dataToPost
        )
        // console.log('delete bot response', response)
        return {
          retour: 1,
          data: response.data
        }
      } catch (err) {
        // console.log('delete bot err', err)
        return {
          retour: 0,
          data: err
        }
      }
    }
  },

  watch: {
    'agent': function (val, oldVal) {
      this.init()
    },
    '$store.state._Sites.siteSelected': function (v) {
      this.getOptions()
    }
  }
}
</script>
<style scoped>
  .hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/ChatBot.vue